import { i18n } from "@/main.js";

export default {
  init: function (app) {
    // define app
    this.app = app;

    // define services
    this.lang = app.lang;
    this.toolbar = app.toolbar;
    this.insertion = app.insertion;
  },
  modals: {
    multigender_text:
      '<form action="">' +
      '<div class="form-item">' +
      '<label id="multigender_default" ></label>' +
      '<input type="text" name="default" />' +
      "</div>" +
      '<div class="form-item">' +
      '<label id="multigender_female" ></label>' +
      '<input type="text" name="female" />' +
      "</div>" +
      '<div class="form-item">' +
      '<label id="multigender_male" ></label>' +
      '<input type="text" name="male" />' +
      "</div>" +
      "</form>",
  },
  // messages
  onmodal: {
    multigender_text: {
      open: function ($modal) {
        const body = $modal.getBody();
        body.find("#multigender_default").nodes[0].innerHTML = i18n.t("gender.default");
        body.find("#multigender_female").nodes[0].innerHTML = i18n.t("gender.female");
        body.find("#multigender_male").nodes[0].innerHTML = i18n.t("gender.male");
      },
      opened: function ($modal, $form) {
        $form.getField("default").focus();
      },
      insert: function ($modal, $form) {
        const data = $form.getData();
        this._insert(data);
      },
      closed: function () {
        const d = document.getElementById("redactor-modal");
        d.parentNode.removeChild(d);
      },
    },
  },

  // public
  start: function () {
    // create the button data
    const buttonData = {
      title: i18n.t("redactor.multigender_text"),
      api: "plugin.multigender_text.open",
    };

    // create the button
    this.toolbar.addButton("multigender_text", buttonData);
  },
  open: function () {
    const options = {
      title: i18n.t("redactor.multigender_text"),
      width: "600px",
      name: "multigender_text",
      handle: "insert",
      commands: {
        insert: { title: i18n.t("actions.add") },
        cancel: { title: i18n.t("actions.cancel") },
      },
    };

    this.app.api("module.modal.build", options);
  },

  // private
  _insert: function (data) {
    this.app.api("module.modal.close");
    const pattern = ":";
    const r = new RegExp(pattern, "g");
    const textD = data.default.replace(r, "");
    const textF = data.female.replace(r, "");
    const textM = data.male.replace(r, "");
    this.insertion.insertText("${g:" + textF + ":" + textM + ":" + textD + "}");
  },
};
